import { useEffect } from 'react';

/**
 * Close a modal/dialog on the Escape key. Pass the same handler you use for the
 * backdrop tap so keyboard users have a way out too.
 */
export function useEscapeKey(onEscape, enabled = true) {
  useEffect(() => {
    if (!enabled || typeof onEscape !== 'function') return undefined;
    function onKey(e) {
      if (e.key === 'Escape') onEscape();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onEscape, enabled]);
}
